<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        Does the course offer enough resources (videos, web links, etc…) to allow you to find
        information relevant to answer questions you may have about the course content? Yes or No,
        Why?
      </p>

      <s-textarea v-model="inputs.input1" outlined />
    </v-form>
  </div>
</template>

<script>
import STextarea from '@/common/components/STextarea.vue';
import DynamicQuestionMixin from '../../mixins/dynamic-question';

export default {
  name: 'OleMissSurveyQ6',
  components: {
    STextarea,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        input1: null,
      },
    };
  },
};
</script>
<style scoped></style>
